export default __webpack_public_path__ + "static/media/share_link.6844f303.svg";